import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { HeadingItem as MenuHeadingItem } from '@atlaskit/menu';
import { overrideStyleFunction, sectionHeaderStyle } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';

var HeadingItem = function HeadingItem(props) {
  var _useShouldNestedEleme = useShouldNestedElementRender(),
      shouldRender = _useShouldNestedEleme.shouldRender;

  if (!shouldRender) {
    return null;
  }

  var cssFn = overrideStyleFunction(sectionHeaderStyle, props.cssFn);
  return /*#__PURE__*/React.createElement(MenuHeadingItem, _extends({}, props, {
    cssFn: cssFn
  }));
};

export default HeadingItem;